export default class BillingService {
  constructor(http) {
    this.http = http;
  }

  _q(params) {
    const q = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v === undefined || v === null || v === "") return;
      q.set(k, String(v));
    });
    const s = q.toString();
    return s ? `?${s}` : "";
  }

  async getBootstrap({ schoolid, schoolId, school_year_id, schoolYearId }) {
    const sid = schoolid ?? schoolId;
    const yid = school_year_id ?? schoolYearId;
    const q = new URLSearchParams();
    if (sid) q.set("schoolid", String(sid));
    if (yid !== undefined && yid !== null && yid !== "")
      q.set("school_year_id", String(yid));
    const qs = q.toString();
    return this.http.fetch(
      `/api/billing/bootstrap${qs ? `?${qs}` : ""}`,
      { method: "GET" },
    );
  }

  async getSessions({ school_year_id, schoolYearId, hierarchy_one, hierarchyOne }) {
    const yid = school_year_id ?? schoolYearId;
    const q = new URLSearchParams();
    q.set("school_year_id", String(yid));
    const h = hierarchy_one ?? hierarchyOne;
    if (h !== undefined && h !== null && h !== "")
      q.set("hierarchy_one", String(h));
    return this.http.fetch(`/api/billing/sessions?${q}`, { method: "GET" });
  }

  async createSession(body) {
    return this.http.fetch(`/api/billing/sessions`, {
      method: "POST",
      body: JSON.stringify(body),
    });
  }

  async patchSession(id, body) {
    return this.http.fetch(`/api/billing/sessions/${encodeURIComponent(id)}`, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  }

  async deleteSession(id) {
    return this.http.fetch(`/api/billing/sessions/${encodeURIComponent(id)}`, {
      method: "DELETE",
    });
  }

  async reorderSessions(body) {
    return this.http.fetch(`/api/billing/sessions/reorder`, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  }

  async getSessionItems(sessionId) {
    return this.http.fetch(
      `/api/billing/sessions/${encodeURIComponent(sessionId)}/items`,
      { method: "GET" },
    );
  }

  async createSessionItem(sessionId, body) {
    return this.http.fetch(
      `/api/billing/sessions/${encodeURIComponent(sessionId)}/items`,
      {
        method: "POST",
        body: JSON.stringify(body),
      },
    );
  }

  async syncSessionItems(sessionId, items) {
    return this.http.fetch(
      `/api/billing/sessions/${encodeURIComponent(sessionId)}/items/sync`,
      {
        method: "PUT",
        body: JSON.stringify({ items }),
      },
    );
  }

  async patchItem(itemId, body) {
    return this.http.fetch(`/api/billing/items/${encodeURIComponent(itemId)}`, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  }

  async deleteItem(itemId) {
    return this.http.fetch(`/api/billing/items/${encodeURIComponent(itemId)}`, {
      method: "DELETE",
    });
  }

  async reorderItems(body) {
    return this.http.fetch(`/api/billing/items/reorder`, {
      method: "PATCH",
      body: JSON.stringify(body),
    });
  }

  async loadPreviousItems(body) {
    return this.http.fetch(`/api/billing/items/load-previous`, {
      method: "POST",
      body: JSON.stringify(body),
    });
  }

  async getRecords(params) {
    return this.http.fetch(
      `/api/billing/records${this._q(params)}`,
      { method: "GET" },
    );
  }

  async upsertOneRecord(body) {
    return this.http.fetch(`/api/billing/records/upsert-one`, {
      method: "PUT",
      body: JSON.stringify(body),
    });
  }

  async upsertBulkRecords(body) {
    return this.http.fetch(`/api/billing/records/upsert-bulk`, {
      method: "PUT",
      body: JSON.stringify(body),
    });
  }

  async loadPreviousRecords(body) {
    return this.http.fetch(`/api/billing/records/load-previous`, {
      method: "POST",
      body: JSON.stringify(body),
    });
  }

  async getPrintPayload(params) {
    return this.http.fetch(
      `/api/billing/print-payload${this._q(params)}`,
      { method: "GET" },
    );
  }

  async getPrintPayloadBulk(params) {
    return this.http.fetch(
      `/api/billing/print-payload/bulk${this._q(params)}`,
      { method: "GET" },
    );
  }
}
